import { connect } from 'react-redux';
import withPGTranslation from '@app/config/withPGTranslation';
import AdvisorBonus from './advisor_bonus';

const mapStateToProps = ({
  user: { user }
}: { user: { user: User.Details }, orderId: number }) => ({
  clientAvailableCredit: ((user && user.clientAvailableCredit) || '0'),
  user
});
export default connect(
  mapStateToProps
)(withPGTranslation(AdvisorBonus));
